/** 미션펀드 공식 메인 사이트 */
export const MISSIONFUND_HOME_URL = 'https://missionfund.org/';

/** 미션펀드 — 개인정보 처리방침 */
export const MISSIONFUND_PRIVACY_POLICY_URL =
  'https://my.missionfund.org/policy/';

/** 미션펀드 — 서비스 약관 및 운영 정책 */
export const MISSIONFUND_TERMS_OF_SERVICE_URL =
  'https://my.missionfund.org/terms/';

/**
 * 기빙어카운트(기부계좌) 사이트로 가는 SSO 진입 주소
 * - 토큰을 주소에 붙이지 않는다. sapi 가 로그인 쿠키를 확인하고 1회용 코드를 붙여 myaccount 로 보낸다
 * - refresh 쿠키가 Path=/auth 라서 반드시 /auth/sso/start 로 가야 한다
 * - 개발 빌드는 REACT_APP_API_BASE(devsapi) 를 따라 개발 myaccount 로 간다
 */
export const MISSIONFUND_MYACCOUNT_SSO_URL = `${(
  (process.env.REACT_APP_API_BASE as string | undefined)?.trim() || 'https://sapi.missionfund.org'
).replace(/\/+$/, '')}/auth/sso/start?target=myaccount&movepath=${encodeURIComponent('/')}`;

/** 미션펀드 공식 사이트 — 모금지원 상담 */
export const MISSIONFUND_SUPPORT_URL = 'https://missionfund.org/support/';
